import { Timer } from 'three'
import gsap from 'gsap'
import WebGLContext from './WebGLContext'

/**
 * Render loop. Drives a single scene object that implements:
 *   update(delta), resize(width, height, top), scene, camera,
 *   jumped (optional) — a Set of objects moved without animating since the last frame,
 *   so the motion blur doesn't streak them; cleared after every frame
 * Runs on gsap's ticker after Lenis, so the page has scrolled before the DOM is measured.
 */
export default class Three {
	constructor(scene) {
		this.context = new WebGLContext()
		this.scene = scene
		this.timer = new Timer()
	}

	run() {
		this.#resize()
		window.addEventListener('resize', () => this.#resize())
		gsap.ticker.add(() => this.#tick(performance.now()))
	}

	#tick(timestamp) {
		this.timer.update(timestamp)
		const delta = this.timer.getDelta()
		this.context.follow(window.scrollY)
		this.scene.update(delta)
		this.context.render(this.scene.scene, this.scene.camera, delta, this.scene.jumped)
		this.scene.jumped?.clear()
	}

	#resize() {
		this.context.resize()
		this.scene.resize(this.context.width, this.context.height, this.context.bleed)
	}
}
